import DashboardIcon from "@mui/icons-material/Dashboard";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import VideoCameraBackIcon from "@mui/icons-material/VideoCameraBack";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import EmergencyRecordingIcon from "@mui/icons-material/EmergencyRecording";
import Alerts from "./Pages/Alerts";
import ManuDashboard from "./Pages/ManuDashboard/ManuDashboard";

// MAIN PAGES
// import AlertsPageV2 from "views/Pages/AlertsPageV2.js";
//import TicketsPage from "views/Pages/TicketsPage.js";
// import TicketsPageV2 from "views/Pages/TicketsPageV2.js";
//import StreamsPage from "views/Pages/StreamsPage.js";
// import AdminPageV2 from "views/Admin/AdminPageV2";
// import DashboardPageAppMfgV2 from "views/Pages/DashboardPageAppMfgV2/index";

// import AnalyticsMonitor from "views/Pages/DashboardPageAppMfgV2/AnalyticsMonitor";
// import AdminPageLocations from "views/Admin/AdminPageLocations.js";
// import AdminPageCameras from "views/Admin/AdminPageCameras.js";
// import AdminPageUserListV2 from "views/Admin/AdminPageUserListV2";

// import CameraStatusAndConfiguration from "views/Pages/DashboardPageAppMfgV2/QualityDashboard/CameraStatusAndConfiguration";

export var dashRoutesUserManuAdmin = [
  {
    path: "/dashboard",
    name: "Analytics",
    icon: (color) => <FactCheckIcon style={{ color }} />,
    component: ManuDashboard, //DashboardPageAppMfgV2,
    layout: "/app",
  },
  // {
  //   path: "/alerts",
  //   name: "Alerts",
  //   icon: (color) => <FactCheckIcon style={{ color }} />,
  //   component: Alerts, //DashboardPageAppMfgV2,
  //   layout: "/app",
  // },
  // {
  //   path: "/camerastatus",
  //   name: "Camera Status",
  //   icon: EmergencyRecordingIcon,
  //   component: CameraStatusAndConfiguration,
  //   layout: "/app",
  // },
  // {
  //   path: "/admin",
  //   name: "Admin",
  //   icon: AdminPanelSettingsIcon,
  //   component: <div>AdminPagev2</div>, //AdminPageV2,
  //   layout: "/app",
  //   collapse: true,
  //   state: "statusCollapse",
  //   views: [
  //     {
  //       path: "/admin/users",
  //       name: "Users",
  //       icon: AccountCircleIcon,
  //       component: <div>AdminPageUserListV2</div>, //AdminPageUserListV2,
  //       layout: "/app",
  //     },
  //     {
  //       path: "/admin/locations",
  //       name: "Locations",
  //       icon: LocationOnIcon,
  //       component: <div>AdminPageLocations</div>, //AdminPageLocations,
  //       layout: "/app",
  //     },
  //     {
  //       path: "/admin/cameras",
  //       name: "Cameras",
  //       icon: VideoCameraBackIcon,
  //       component: <div>AdminPageCameras</div>, //AdminPageCameras,
  //       layout: "/app",
  //     },
  //     //    {
  //     //      path: "/documentation",
  //     //      name: "Documentation",
  //     //      icon: TerminalIcon,
  //     //      component: DocumentationPage,
  //     //      layout: "/app",
  //     //    },
  //   ],
  // },
];

export var dashRoutesUserManu = [
  {
    path: "/dashboard",
    name: "Process Automation",
    icon: FactCheckIcon,
    component: ManuDashboard, //DashboardPageAppMfgV2,
    layout: "/app",
  },
  // {
  //   path: "/alerts",
  //   name: "Alerts",
  //   icon: NotificationsActiveIcon,
  //   component: AlertsPageV2,
  //   layout: "/app",
  // },
  // {
  //   path: "/tickets",
  //   name: "Tickets",
  //   icon: AssignmentIndIcon,
  //   component: TicketsPageV2,
  //   layout: "/app",
  // },
  // {
  //   path: "/camerastatus",
  //   name: "Camera Status",
  //   icon: EmergencyRecordingIcon,
  //   component: CameraStatusAndConfiguration,
  //   layout: "/app",
  // },
];

export var dashRoutesUserAdmin = [
  {
    path: "/dashboard",
    name: "Analytics",
    icon: DashboardIcon,
    component: <div>Dashboard user Analytics Monitor</div>, //AnalyticsMonitor,
    layout: "/app",
  },
  // {
  //   path: "/alerts",
  //   name: "Alerts",
  //   icon: NotificationsActiveIcon,
  //   component: AlertsPageV2,
  //   layout: "/app",
  // },
  // {
  //   path: "/tickets",
  //   name: "Tickets",
  //   icon: AssignmentIndIcon,
  //   component: TicketsPageV2,
  //   layout: "/app",
  // },
  // {
  //   path: "/camerastatus",
  //   name: "Camera Status",
  //   icon: EmergencyRecordingIcon,
  //   component: CameraStatusAndConfiguration,
  //   layout: "/app",
  // },
  // {
  //   path: "/admin",
  //   name: "Admin",
  //   icon: AdminPanelSettingsIcon,
  //   component: AdminPageV2,
  //   layout: "/app",
  //   collapse: true,
  //   state: "statusCollapse",
  //   views: [
  //     {
  //       path: "/admin/users",
  //       name: "Users",
  //       icon: AccountCircleIcon,
  //       component: AdminPageUserListV2,
  //       layout: "/app",
  //     },
  //     {
  //       path: "/admin/locations",
  //       name: "Locations",
  //       icon: LocationOnIcon,
  //       component: AdminPageLocations,
  //       layout: "/app",
  //     },
  //     {
  //       path: "/admin/cameras",
  //       name: "Cameras",
  //       icon: VideoCameraBackIcon,
  //       component: AdminPageCameras,
  //       layout: "/app",
  //     },
  //     //    {
  //     //      path: "/documentation",
  //     //      name: "Documentation",
  //     //      icon: TerminalIcon,
  //     //      component: DocumentationPage,
  //     //      layout: "/app",
  //     //    },
  //   ],
  // },
];

export var dashRoutesUser = [
  {
    path: "/dashboard",
    name: "Analytics",
    icon: DashboardIcon,
    component: <div>Dashboard user Analytics Monitor</div>, //AnalyticsMonitor,
    layout: "/app",
  },
  // {
  //   path: "/alerts",
  //   name: "Alerts",
  //   icon: NotificationsActiveIcon,
  //   component: AlertsPageV2,
  //   layout: "/app",
  // },
  // {
  //   path: "/tickets",
  //   name: "Tickets",
  //   icon: AssignmentIndIcon,
  //   component: TicketsPageV2,
  //   layout: "/app",
  // },
  // {
  //   path: "/camerastatus",
  //   name: "Camera Status",
  //   icon: EmergencyRecordingIcon,
  //   component: CameraStatusAndConfiguration,
  //   layout: "/app",
  // },
];



